import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPromptTextToVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"prompt-text-to-video"} maskId="square-outlined-radius-0-stroke-1-IconPromptTextToVideo"><path d="M1.5 5V3.5H6H9.5V5" stroke="currentColor"/><path d="M5.5 3.5V11.5M5.5 11.5H4M5.5 11.5H7" stroke="currentColor"/><path d="M5.5 15V20.5H20.5V5.5H13" stroke="currentColor"/><path d="M11 16V10L15.5 13L11 16Z" stroke="currentColor"/></CentralIconBase>;
}));

export default IconPromptTextToVideo;
